import { FilterType } from "@/Pages/Cases/filtering/FilterType";

import type { DashboardFiltersInUser } from "@/Pages/Cases/filtering/DashboardFiltersInUser";

export const parseDashboard1Filter = (rawFilter: string): DashboardFiltersInUser => {
  const item = JSON.parse(rawFilter);
  return {
    id: item.id,
    name: item.name,
    [FilterType.hospitals]: JSON.parse(item[FilterType.hospitals] ?? "[]"),
    [FilterType.ems]: JSON.parse(item["emsAgencies"] ?? "[]"),
    [FilterType.complaints]: JSON.parse(item[FilterType.complaints] ?? "[]"),
  };
};
